import { checkEnrichedName } from 'bto-models/utils/string';
import DateFilterService from "../../services/date-filter-service";

export default class MyBetItemsModel {
  constructor(data) {
    /**
     * @type {string}
     */
    this.type = data.t;
    /**
     * @type {string}
     */
    this.itemStatusName = data.s;
    /**
     * @type {string}
     */
    this.sportName = data.sn;
    /**
     * @type {string}
     */
    this.categoryName = data.cn;
    /**
     * @type {string}
     */
    this.tournamentName = data.tn;
    /**
     * @type {number}
     */
    this.matchID = data.mid;
    /**
     * @type {string}
     */
    this.apiDateTime = data.d;
    /**
     * @type {string}
     */
    this.eventDateString = DateFilterService.localDate(
      data.d,
      "datetime",
      APP_SETTINGS.formatting.fullDateFormat,
      APP_SETTINGS.formatting.shortTimeFormat,
      true
    );
    /**
     * @type {string}
     */
    this.matchTitle = data.mt;
    /**
     * @type {string}
     */
    this.homeTeam = data.ht;
    /**
     * @type {string}
     */
    this.guestTeam = data.at;
    /**
     * @type {string}
     */
    this.market = checkEnrichedName(data.m, data.ht, data.at, data.sbv);
    /**
     * @type {boolean}
     */
    this.banker = data.b;
    /**
     * Outcome Id
     * @type {number}
     */
    this.oddId = data.oid;
    /**
     * @type {string}
     */
    this.odd = data.o;
    /**
     * @type {string}
     */
    this.eventCode = data.ec;
    /**
     * @type {number}
     */
    this.itemStatusId = data.isid;
    /**
     * Market Id
     * @type {number}
     */
    this.oddTypeId = data.otid;
    /**
     * @type {number}
     */
    this.sportId = data.sid;
    /**
     * @type {string}
     */
    this.specialBetValue = data.sbv;
    /**
     * @type {number}
     */
    this.tournamentId = data.tid;
    /**
     * @type {number}
     */
    this.categoryId = data.cid;
    /**
     * Market name
     * @type {string}
     */
    this.oddTypeName = data.otn;
    /**
     * Original market name
     * @type {string}
     */
    this.originalMarketName = data.ootn;
    /**
     * @type {string}
     */
    this.outcomeName = checkEnrichedName(data.on, data.ht, data.at, data.sbv);
    /**
     * Original outcome name if available
     * @type {string | undefined}
     */
    this.originalOutcomeName = data.oon;
    /**
     * @type {number}
     */
    this.itemTypeId = data.itid;
    /**
     * @type {string}
     */
    this.identifier = data.iden;
    /**
     * @type {string}
     */
    this.specifier = data.spec;
    /**
     * @type {number}
     */
    this.playerOddTypeId = data.potid;
    /**
     * @type {boolean}
     */
    this.cashoutAvailable = data.cs;
    /**
     * @type {number}
     */
    this.betRadarId = data.brid;
    /**
     * Match score if available
     * @type {number | null}
     */
    this.score = data.sc;
    /**
     * Is tournament US
     * @type {boolean}
     */
    this.isUS = data.tus;

     /**
     * Is match race cast fore/tricast
     * @type {boolean}
     */
    this.isRaceCast = data.isfctc;
    /**
     * @type {number}
     * Boosted odds tournament template id
     */
    this.tournamentTemplateId = data.ttid || 0;
  }
}
